'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useClearRefinements, useRefinementList } from 'react-instantsearch';
import MobileOnly from 'components/consumer/MobileOnly';
import MobileModal from 'components/consumer/MobileModal';
import CtaButton from 'components/essentials/Cta/CtaButton';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import getAdvancedSearchActiveFilterCount from 'components/consumer/consumer-search/advanced-search-next/hooks/getAdvancedSearchActiveFilterCount';
import MobileProductFiltersButton from 'components/consumer/consumer-search/advanced-search-next/components/AlgoliaHits/components/MobileProductFilters/components/MobileProductFiltersButton';
import MobileProductListingColorFilter from 'components/consumer/consumer-search/advanced-search-next/components/AlgoliaHits/components/MobileProductFilters/components/MobileProductListingColorFilter';
import ProductClearAllFiltersButton from 'components/consumer/consumer-search/advanced-search-next/components/AlgoliaHits/components/MobileProductFilters/components/ProductClearAllFiltersButton';
import MobileProductListingFilterWrapper from 'components/consumer/ProductListingPage/components/mobile/MobileProductListingFiltersButtonAndModal/MobileProductListingFilterWrapper';
import CategoryAlgoliaMobileFacetFilter from '../CategoryAlgoliaMobileFacetFilter';
import { getSkipFilterIds } from '../../categoryPageSlugUtils';
import { PAGE_TYPE, getCategoryPageTypeConfig } from '../../categoryPageTypes';
const CategoryAlgoliaMobileFilters = t0 => {
  const $ = _c(63);
  const {
    filters,
    pageType: t1,
    selectedFacets,
    onToggleFacet,
    productsCount
  } = t0;
  const pageType = t1 === undefined ? PAGE_TYPE.CATEGORY : t1;
  let t2;
  if ($[0] !== pageType) {
    t2 = getCategoryPageTypeConfig(pageType);
    $[0] = pageType;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    showReadyToShipToggle,
    showWidthFilter,
    showColorFilter
  } = t2;
  const {
    clearSelectedColors,
    clearSelectedFacets,
    isReadyToShipActive,
    handleToggleReadyToShip,
    minWidth,
    maxWidth,
    handleWidthChange
  } = useAdvancedSearchContext();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      attribute: "option_color",
      skipSuspense: true
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    items: colorFilters,
    refine: refineColorFilters
  } = useRefinementList(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      includedAttributes: ["option_color"]
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    canRefine: canClearColorRefinements,
    refine: clearColorRefinement
  } = useClearRefinements(t4);
  let t5;
  if ($[4] !== filters || $[5] !== pageType) {
    const skipFilterIds = getSkipFilterIds(pageType);
    t5 = (filters || []).filter(filter => !skipFilterIds.has(filter.id) && filter.options?.length > 0);
    $[4] = filters;
    $[5] = pageType;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const dynamicFilters = t5;
  let t6;
  if ($[7] !== selectedFacets) {
    t6 = Object.values(selectedFacets || {}).some(_temp) || false;
    $[7] = selectedFacets;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const hasSelectedFacets = t6;
  const canClear = hasSelectedFacets || canClearColorRefinements || isReadyToShipActive || !!(minWidth || maxWidth);
  const [isMobileFiltersModalOpen, setIsMobileFiltersModalOpen] = useState(false);
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsMobileFiltersModalOpen(true);
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleOpenModal = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsMobileFiltersModalOpen(false);
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleCloseModal = t8;
  let t9;
  if ($[11] !== clearColorRefinement || $[12] !== clearSelectedColors || $[13] !== clearSelectedFacets || $[14] !== handleToggleReadyToShip || $[15] !== handleWidthChange || $[16] !== isReadyToShipActive || $[17] !== maxWidth || $[18] !== minWidth) {
    t9 = () => {
      clearSelectedFacets?.();
      clearColorRefinement();
      clearSelectedColors?.();
      if (isReadyToShipActive) {
        handleToggleReadyToShip?.(false);
      }
      if (minWidth || maxWidth) {
        handleWidthChange?.("", "");
      }
    };
    $[11] = clearColorRefinement;
    $[12] = clearSelectedColors;
    $[13] = clearSelectedFacets;
    $[14] = handleToggleReadyToShip;
    $[15] = handleWidthChange;
    $[16] = isReadyToShipActive;
    $[17] = maxWidth;
    $[18] = minWidth;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const clearRefinement = t9;
  let t10;
  if ($[20] !== colorFilters || $[21] !== isReadyToShipActive || $[22] !== maxWidth || $[23] !== minWidth || $[24] !== selectedFacets) {
    t10 = getAdvancedSearchActiveFilterCount({
      colorItems: colorFilters,
      selectedFacets,
      isReadyToShipActive,
      minWidth,
      maxWidth
    });
    $[20] = colorFilters;
    $[21] = isReadyToShipActive;
    $[22] = maxWidth;
    $[23] = minWidth;
    $[24] = selectedFacets;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const activeFilterCount = t10;
  let t11;
  if ($[26] !== activeFilterCount) {
    t11 = <MobileProductFiltersButton activeFilterCount={activeFilterCount} onClick={handleOpenModal} />;
    $[26] = activeFilterCount;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== canClear || $[29] !== clearRefinement) {
    t12 = <ProductClearAllFiltersButton canClear={canClear} clearRefinement={clearRefinement} />;
    $[28] = canClear;
    $[29] = clearRefinement;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const t13 = productsCount || 0;
  const t14 = productsCount === 1 ? "" : "s";
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <CtaButton block={true} onClick={handleCloseModal}>Done ({t13} result{t14})</CtaButton>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filters";
  let t17;
  if ($[34] !== handleToggleReadyToShip || $[35] !== isReadyToShipActive || $[36] !== showReadyToShipToggle) {
    t17 = showReadyToShipToggle && <MobileProductListingFilterWrapper id="quickship"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} showLabelOnMobile={true} /></MobileProductListingFilterWrapper>;
    $[34] = handleToggleReadyToShip;
    $[35] = isReadyToShipActive;
    $[36] = showReadyToShipToggle;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== showWidthFilter) {
    t18 = showWidthFilter && <MobileProductListingFilterWrapper id="widthRange" label="Width"><WidthRangeFilter /></MobileProductListingFilterWrapper>;
    $[38] = showWidthFilter;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== dynamicFilters || $[41] !== onToggleFacet || $[42] !== selectedFacets) {
    let t20;
    if ($[44] !== onToggleFacet || $[45] !== selectedFacets) {
      t20 = filter_0 => <MobileProductListingFilterWrapper id={filter_0.id} key={filter_0.id} label={filter_0.label}><CategoryAlgoliaMobileFacetFilter attribute={filter_0.id} label={filter_0.label} options={filter_0.options} selectedValues={selectedFacets?.[filter_0.id] || new Set()} onToggle={onToggleFacet} /></MobileProductListingFilterWrapper>;
      $[44] = onToggleFacet;
      $[45] = selectedFacets;
      $[46] = t20;
    } else {
      t20 = $[46];
    }
    t19 = dynamicFilters.map(t20);
    $[40] = dynamicFilters;
    $[41] = onToggleFacet;
    $[42] = selectedFacets;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[47] !== colorFilters || $[48] !== refineColorFilters || $[49] !== showColorFilter) {
    t20 = showColorFilter && <MobileProductListingColorFilter colorFilters={colorFilters} refineColorFilters={refineColorFilters} />;
    $[47] = colorFilters;
    $[48] = refineColorFilters;
    $[49] = showColorFilter;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== isMobileFiltersModalOpen || $[52] !== t12 || $[53] !== t15 || $[54] !== t16 || $[55] !== t17 || $[56] !== t18 || $[57] !== t19 || $[58] !== t20) {
    t21 = <MobileOnly><div className="md:hidden"><MobileModal enableHashHistory={false} headerRight={t12} isFullHeight={true} isOpen={isMobileFiltersModalOpen} onClose={handleCloseModal} stickyFooter={t15} title={t16}>{t17}{t18}{t19}{t20}</MobileModal></div></MobileOnly>;
    $[51] = isMobileFiltersModalOpen;
    $[52] = t12;
    $[53] = t15;
    $[54] = t16;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
    $[58] = t20;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== t11 || $[61] !== t21) {
    t22 = <>{t11}{t21}</>;
    $[60] = t11;
    $[61] = t21;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  return t22;
};
CategoryAlgoliaMobileFilters.propTypes = {
  filters: PropTypes.array,
  pageType: PropTypes.oneOf(Object.values(PAGE_TYPE)),
  selectedFacets: PropTypes.object,
  onToggleFacet: PropTypes.func,
  productsCount: PropTypes.number
};
export default CategoryAlgoliaMobileFilters;
function _temp(values) {
  return values?.size > 0;
}